export interface BlockedTimeScope {
  date: number;
  startTime: number;
  endTime: number;
  allServices?: boolean;
  services?: string[];
  allResources?: boolean;
  resources?: string[];
}

/**
 * Two blocked times intersect when they cover a common (day, time, service, resource)
 * tuple: same day, overlapping time window, overlapping service scope AND overlapping
 * resource scope. An empty/all scope on either side counts as covering everything.
 */
export function blockedTimesIntersect(a: BlockedTimeScope, b: BlockedTimeScope): boolean {
  return a.date === b.date
    && timeOverlaps(a, b)
    && servicesOverlap(a, b)
    && resourcesOverlap(a, b);
}

function timeOverlaps(a: BlockedTimeScope, b: BlockedTimeScope): boolean {
  return a.startTime < b.endTime && b.startTime < a.endTime;
}

function servicesOverlap(a: BlockedTimeScope, b: BlockedTimeScope): boolean {
  if (a.allServices || b.allServices) {
    return true;
  }

  const aServices = a.services ?? [];
  const bServices = b.services ?? [];

  return aServices.some(serviceId => bServices.includes(serviceId));
}

function resourcesOverlap(a: BlockedTimeScope, b: BlockedTimeScope): boolean {
  const aAllResources = a.allResources || !a.resources?.length;
  const bAllResources = b.allResources || !b.resources?.length;
  if (aAllResources || bAllResources) {
    return true;
  }

  return a.resources.some(resourceId => b.resources.includes(resourceId));
}
